import { addCustomMarkCommand, removeCustomMarkCommand, getMarkAttrs } from "../../../commands/custom-commands";
import { customSchema, validBackgroundColorClasses } from "../../../schemas/custom-schema";

export default class BackgroundColorDropdown {
	constructor(editorView, containerElement) {
		this.view = editorView;
		this.containerElement = document.createElement("div");
		this.containerElement.className = "editor-dropdown-container";
		const dropdownLabel = document.createElement("label");
		dropdownLabel.className = "editor-dropdown-label";
		dropdownLabel.textContent = "Color de fondo: ";
		this.dropdownElement = document.createElement("select");
		this.dropdownElement.className = "editor-dropdown";
		this.dropdownElement.title = "Color de fondo de la selección"
		const defaultOption = document.createElement("option"),
			options = validBackgroundColorClasses.map(option => {
				const opt = document.createElement("option");
				opt.textContent = option.label;
				opt.value = option.value;

				return opt;
			});
		defaultOption.value = "";
		defaultOption.textContent = "Por defecto";
		options.unshift(defaultOption);
		options.forEach(option => this.dropdownElement.appendChild(option));

		this.changeAction = this.dropdownChangeCallback();
		this.dropdownElement.addEventListener("change", this.changeAction);
		this.containerElement.appendChild(dropdownLabel);
		this.containerElement.appendChild(this.dropdownElement);
		containerElement.appendChild(this.containerElement);
		this.update(editorView);
	}

	update(view) {
		const { value: cssClass } = this.dropdownElement,
			currentOption = getMarkAttrs(view.state, customSchema.marks.backgroundColor),
			isEnabled = addCustomMarkCommand(
				customSchema.marks.backgroundColor,
				{ className: cssClass },
				[],
				[/*customSchema.nodes.note*/],
				![/*"note", */"ghost"].includes(view.state.doc.type.name)
			)(view.state, null);

		if(!currentOption) {
			this.dropdownElement.value = "";
		} else {
			this.dropdownElement.value = currentOption.className;
		}

		this.dropdownElement.disabled = !isEnabled;
		this.view = view;
	}

	destroy() {
		this.dropdownElement.removeEventListener("click", this.changeAction);
		this.containerElement.remove();
		this.dropdownElement = null;
		this.containerElement = null;
		this.changeAction = null;
		this.view = null;
	}

	dropdownChangeCallback() {
		return () => {
			const { value } = this.dropdownElement;

			if(value !== null && value !== "" && !validBackgroundColorClasses.map(color => color.value).includes(value)) {
				return false;
			}

			if(value === "" || value === null) {
				removeCustomMarkCommand(customSchema.marks.backgroundColor)(this.view.state, this.view.dispatch);
			} else {
				addCustomMarkCommand(
					customSchema.marks.backgroundColor,
					{ className: value },
					[],
					[/*customSchema.nodes.note*/],
					![/*"note", */"ghost"].includes(this.view.state.doc.type.name)
				)(this.view.state, this.view.dispatch);
			}
			this.view.focus();
		}
	}
}
